const normalizeBrakeText = (...vals) =>
  vals.map((v) => String(v || '').toLowerCase()).join(' ');

/**
 * Returns true if the product appears to be a brake pad product based on
 * its category, type, name, title, or SKU.
 * @param {{ category?: string, type?: string, name?: string, title?: string, sku?: string }} product
 */
export const isBrakePadProduct = (product = {}) => {
  const text = normalizeBrakeText(
    product.category,
    product.type,
    product.name,
    product.title,
    product.sku
  );
  return (
    /brake\s*pads?/.test(text) ||
    /\bkcc[-\s]?bp\b/.test(text) ||
    /\bbp[-\s]?\d/.test(text)
  );
};

/**
 * Returns true if the product appears to be a brake rotor/disc product.
 * @param {{ category?: string, type?: string, name?: string, title?: string, sku?: string }} product
 */
export const isBrakeRotorProduct = (product = {}) => {
  const text = normalizeBrakeText(
    product.category,
    product.type,
    product.name,
    product.title,
    product.sku
  );
  return (
    /brake\s*(rotors?|discs?)/.test(text) ||
    /\brotors?\b/.test(text) ||
    /\bdiscs?\b/.test(text) ||
    /\bkcc[-\s]?(bd|br)\b/.test(text)
  );
};

/**
 * Returns true if the coating value represents "no coating" / uncoated.
 * @param {string} value
 */
export const isNonCoated = (value) => {
  const normalized = String(value || '').trim().toLowerCase();
  return ['non-coated', 'non coated', 'none', 'no', 'not coated', 'uncoated'].includes(
    normalized
  );
};
